import { render, staticRenderFns } from "./View_total.vue?vue&type=template&id=97da35ea&scoped=true&"
import script from "./View_total.vue?vue&type=script&lang=js&"
export * from "./View_total.vue?vue&type=script&lang=js&"
import style0 from "./View_total.vue?vue&type=style&index=0&id=97da35ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97da35ea",
  null
  
)

export default component.exports